import React, {useContext, useEffect, useState} from "react";
import FlightCalculator from "./flight-calculator/flight-calculator";
import GettingStartedContext from "../utils/GettingStartedContext";
import {STAND_ALONE} from "../utils/consts";

const FlightTimeBlock = ({lang, widgetKey}) => {

  const [loading, setLoading] = useState(true);

  const {
    link,
    setData,
    getLink
  } = useContext(GettingStartedContext);

  useEffect(() => {
    fetch(getLink('getAllContent'))
      .then((response) => response.json())
      .then((json) => {
        setData(json);
        setLoading(false);
      });
  }, [])

  if (loading) {
    return null
  }
  return <FlightCalculator
    widgetKey={widgetKey}
    type={STAND_ALONE} />

}

export default FlightTimeBlock;
